import { useState } from "react";
import { Cpu, BatteryCharging, Grid3x3, ImageOff } from "lucide-react";
import { ComponentInfo } from "./ComponentInfo";

const ICON = { Inverter: Cpu, Batteria: BatteryCharging, "Moduli fotovoltaici": Grid3x3 };
const NOTA = { dedotto: "modello dedotto da tensione e capacità lette", non_disponibile: "non trovato in monitoraggio e ordini", ordine: "dall'ordine Torri" };

// Componenti dell'impianto (dal monitoraggio) con codice e foto dal listino
export function PlantComponents({ list }) {
  const [sel, setSel] = useState(null);
  if (!list?.length) return null;
  return (
    <div className="grid gap-2 sm:grid-cols-3" data-testid="plant-components">
      <ComponentInfo c={sel} onClose={() => setSel(null)} />
      {list.map((c) => {
        const I = ICON[c.tipo] || Cpu;
        return (
          <button type="button" onClick={() => setSel(c)} key={c.tipo + (c.codice || c.modello)} className="flex items-center gap-3 rounded-xl border border-neutral-800 bg-neutral-900/60 p-2.5 text-left transition-colors hover:border-[#C17F59]" data-testid={`plant-component-${c.tipo.split(" ")[0].toLowerCase()}`}>
            <div className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white">
              {c.foto ? <img src={encodeURI(decodeURI(c.foto))} alt={c.codice || c.tipo} className="h-full w-full object-contain" loading="lazy" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                : c.codice ? <ImageOff className="h-5 w-5 text-neutral-400" /> : <I className="h-6 w-6 text-neutral-400" />}
            </div>
            <div className="min-w-0 text-xs">
              <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-neutral-500"><I className="h-3 w-3" />{c.tipo}{c.quantita ? ` × ${c.quantita}` : ""}</span>
              <b className="block truncate font-mono text-neutral-100" data-testid={`plant-component-code-${c.tipo.split(" ")[0].toLowerCase()}`}>{c.codice || c.modello || "—"}</b>
              {c.codice && c.modello && <span className="block truncate text-neutral-400">{c.modello}</span>}
              {NOTA[c.fonte] && <span className="block truncate text-[10px] text-neutral-500">{NOTA[c.fonte]}{c.ordine ? ` ${c.ordine}` : ""}</span>}
            </div>
          </button>
        );
      })}
    </div>
  );
}
